import * as React from "react";

export class PilotChip extends React.PureComponent {
    public render() {
        return <span className="pilot-chip">Pilot only</span>;
    }
}
